// Backend filter param of the contracts list API — not renameable client-side.
export const USER_PROFILE_TAB_CONTRACTS_SCOPE_FILTER_KEY = 'inhabitant'

export const USER_PROFILE_TAB_CONTRACTS_QA_NAME = {
  addNew: 'userProfileTabContractsAddNew',
  table: 'userProfileTabContractsTable',
}
